import { render, staticRenderFns } from "./thirdPartyCallRecord.vue?vue&type=template&id=55391d67&scoped=true&"
import script from "./thirdPartyCallRecord.vue?vue&type=script&lang=js&"
export * from "./thirdPartyCallRecord.vue?vue&type=script&lang=js&"
import style0 from "./thirdPartyCallRecord.vue?vue&type=style&index=0&id=55391d67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55391d67",
  null
  
)

component.options.__file = "thirdPartyCallRecord.vue"
export default component.exports